import { PaletteColorOptions, createTheme } from "@mui/material";
import '@fontsource-variable/open-sans';
import '@fontsource/mrs-saint-delafield';

const colorPrimary:PaletteColorOptions = {
    light: '#98b89e50',
    main: '#98b89e',
    dark: '#68886e',
    contrastText: '#fff'
};

const colorSecondary:PaletteColorOptions = {
    light: '#b39983',
    main: '#836953',
    dark: '#533923',
    contrastText:'#fff'
};

export const theme = createTheme({
    palette: {
        primary: colorPrimary,
        secondary: colorSecondary,
        background: {
            default: '#fff'
        }
    },
    typography: {
        fontFamily: "'Open Sans Variable', sans-serif",
        h1: {
            color: colorPrimary.main,
            fontSize: '2em'
        },
        h2: {
            fontSize: '1.6em',
            color: colorSecondary.main
        },
        h3: {
            fontSize: '1.3em',
            fontWeight: 400,
            color: colorSecondary.main
        },
        h4: {
            fontSize: '1em',
            fontWeight: 400,
            color: colorPrimary.main
        },
        h5: {
            fontSize: '1em',
            fontWeight: 400,
            color: colorSecondary.main
        },
        h6: {
            fontSize: '1em',
            fontWeight: 400,
            color: colorSecondary.main,
            fontStyle: 'italic'
        },
        body1: {
            fontSize: '1em',
            fontWeight: '100'
        },
        body2: {
            fontSize: '0.8em',
            fontWeight: '100'
        },
        caption: {
            fontFamily: "'Mrs Saint Delafield', cursive",
            fontSize: '1.3em',
            color: '#212121'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "body": {
                    fontFamily: "'Open Sans Variable', sans-serif",
                    background: colorPrimary?.light,
                    fontWeight: 100,

                },
                "h1": {
                    color: colorPrimary.main,
                    fontSize: '2em'
                },
                "h2": {
                    fontSize: '1.6em',
                    color: colorSecondary.main
                },
                "h3": {
                    fontSize: '1.3em',
                    fontWeight: 400,
                    color: colorSecondary.main
                },
                "h4": {
                    fontSize: '1em',
                    fontWeight: 400,
                    color: colorPrimary.main
                },
                "h5": {
                    fontSize: '1em',
                    fontWeight: 400,
                    color: colorSecondary.main
                },
                "h6": {
                    fontSize: '1em',
                    fontWeight: 400,
                    color: colorSecondary.main,
                    fontStyle: 'italic'
                },
                "p": {
                    margin: '0.5em 0',
                    fontSize: '1em',
                    fontWeight: '100'
                },
                fontWeight: '100',
                "a": {
                    fontWeight: '100',
                    textDecoration: 'none',
                    color: colorPrimary?.main,
                    "&:hover": {
                        color: colorPrimary?.dark
                    }
                },
                "footer a": {
                    fontWeight: '100',
                    textDecoration: 'none',
                    color: '#515151',
                    "&:hover": {
                        color: '#212121'
                    }
                }
            }
        }
    }
});